<template>
  <div class="dark__bg">
    <div class="press__component">
      <div class="container__fw">
        <div class="title">Press</div>
        <div class="content">
          <ul class="articles">
            <li>
              <a
                target="_blank"
                href="https://www.youtube.com/watch?v=XXw70jXB5kI&ab_channel=Careerhub-Mauritius"
                >Tejas Pagooah, Engineering Manager at Klanik</a
              >
              <div class="source__link">Year: 2022 / Source: CareerHub.mu</div>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.5plus.mu/guide-et-services/krakathon-2019-le-regne-de-lequipe-kalchul"
                >Krakathon 2019: le règne de l’équipe Kalchul !</a
              >
              <div class="source__link">Year: 2019 / Source: 5plus.mu</div>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.myus.com/blog/top-15-influencers-from-mauritius/"
                >Top 15 Influencers from Mauritius</a
              >
              <div class="source__link">Year: 2019 / Source: MyUS.com</div>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.5plus.mu/guide-et-services/webcup-2018-lsl-digital-gagne-la-guerre-contre-lapocalypse-zombie"
                >WebCup 2018 : LSL Digital gagne la guerre contre l’apocalypse
                zombie</a
              >
              <div class="source__link">Year: 2018 / Source: 5plus.mu</div>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.lexpress.mu/article/331246/webcup-2018-lsl-digital-en-finale-en-novembre"
                >Webcup 2018: LSL Digital en finale en novembre</a
              >
              <div class="source__link">Year: 2018 / Source: lexpress.mu</div>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.lexpress.mu/photos/331052/webcup-lsl-digital-remporte-premier-prix"
                >Webcup: LSL Digital remporte le premier prix</a
              >
              <div class="source__link">Year: 2018 / Source: lexpress.mu</div>
            </li>
            <li>
              <a
                target="_blank"
                href="https://cio-mag.com/webcup-maurice-2018-lsl-digital-arrive-en-tete/"
                >Webcup Maurice 2018 : LSL Digital arrive en tête</a
              >
              <div class="source__link">Year: 2018 / Source: CIO Magazine</div>
            </li>
            <li>
              <a
                target="_blank"
                href="http://ict.io/portrait-dun-developpeur-polyvalent/"
                >Portrait d’un développeur qui a plusieurs cordes à son arc</a
              >
              <div class="source__link">Year: 2017 / Source: ict.io</div>
            </li>
            <li>
              <a
                target="_blank"
                href="http://defimedia.info/tejas-pagooah-awarded-most-entrepreneurial-attitude"
                >Tejas Pagooah: Awarded the most entrepreneurial attitude</a
              >
              <div class="source__link">Year: 2016 / Source: Defi Media</div>
            </li>
            <li>
              <a
                target="_blank"
                href="http://www.lexpress.mu/article/261727/informatique-jeunes-developpeurs-en-herbe"
                >Informatique: ces jeunes développeurs en herbe</a
              >
              <div class="source__link">Year: 2015 / Source: lexpress.mu</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.dark__bg {
  background-image: linear-gradient(60deg, #000000 0%, #1c1c1c 100%);
}

.press__component {
  max-width: 1400px;
  margin: 0 auto;
  padding: calc(var(--gutter) * 3) 15px;
  text-align: left;

  .title {
    font-size: 55px;
    font-weight: 600;
    margin: 0;
    margin-bottom: calc(var(--gutter) * 1.6);
    letter-spacing: -1px;
    color: white;
  }

  .content {
    .articles {
      margin: 0;
      padding: 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 40px;

      li {
        --border-color: rgba(255, 255, 255, 0.2);
        list-style-type: none;
        padding-bottom: calc(var(--gutter) * 2);
        border-bottom: 1px solid var(--border-color);

        .source__link {
          color: var(--color-white);
          margin-top: 10px;
          opacity: 0.7;
          font-size: 13px;
        }

        &:nth-last-child(2) {
          border-bottom: none;
        }

        &:last-child {
          border-bottom: none;
        }

        a {
          color: white;
          font-family: var(--font-noto);
          font-size: 20px;
          text-decoration: none;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .press__component {
    .title {
      font-size: 40px;
    }

    .content {
      .articles {
        grid-template-columns: 1fr;
        grid-gap: calc(var(--gutter) * 1.3);

        li {
          padding-bottom: calc(var(--gutter) * 1.3);

          &:nth-last-child(2) {
            border-bottom: 1px solid var(--border-color);
          }
        }
      }
    }
  }
}
</style>
